import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { finalize } from 'rxjs/operators';

@Injectable()
export class LoadingInterceptorService implements HttpInterceptor {

	public count = 0;

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		localStorage.setItem('loading', 'true');
		this.count++;

		return next.handle(req).pipe(
			finalize(() => {
				this.count--;
				if (this.count <= 0) {
					localStorage.removeItem('loading');
					this.count = 0;
				}
			})
		);
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/interceptors/loading-interceptor.service.ts